var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99984 11.3327C6.73317 11.3327 7.33317 10.7327 7.33317 9.99935C7.33317 9.26602 6.73317 8.66602 5.99984 8.66602C5.2665 8.66602 4.6665 9.26602 4.6665 9.99935C4.6665 10.7327 5.2665 11.3327 5.99984 11.3327ZM9.99984 5.33268H9.33317V3.99935C9.33317 2.15935 7.83984 0.666016 5.99984 0.666016C4.15984 0.666016 2.6665 2.15935 2.6665 3.99935V5.33268H1.99984C1.2665 5.33268 0.666504 5.93268 0.666504 6.66602V13.3327C0.666504 14.066 1.2665 14.666 1.99984 14.666H9.99984C10.7332 14.666 11.3332 14.066 11.3332 13.3327V6.66602C11.3332 5.93268 10.7332 5.33268 9.99984 5.33268ZM3.93317 3.99935C3.93317 2.85935 4.85984 1.93268 5.99984 1.93268C7.13984 1.93268 8.0665 2.85935 8.0665 3.99935V5.33268H3.93317V3.99935ZM9.99984 13.3327H1.99984V6.66602H9.99984V13.3327Z",
    fill: "#818DA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.032000b2ed3fa813543fd42e21b527a0.svg";
export { ForwardRef as ReactComponent };